import { render, staticRenderFns } from "./PageAssetInfo.vue?vue&type=template&id=89ce3ad4&scoped=true"
import script from "./PageAssetInfo.vue?vue&type=script&lang=js"
export * from "./PageAssetInfo.vue?vue&type=script&lang=js"
import style0 from "./PageAssetInfo.vue?vue&type=style&index=0&id=89ce3ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ce3ad4",
  null
  
)

export default component.exports